<div
	class="contract-attachment-dropzone"
	[class.contract-attachment-dropzone--dragging]="isDraggingOver"
	[class.contract-attachment-dropzone--disabled]="isDisabled"
	(dragover)="onDragOver($event)"
	(dragleave)="onDragLeave($event)"
	(drop)="onDrop($event)"
>
	<input
		#fileInput
		hidden
		type="file"
		[accept]="acceptedExtensions"
		[disabled]="isDisabled"
		(change)="onFileSelected($event)"
	/>

	<ng-container *ngIf="isProcessing; else available">
		<mat-spinner diameter="24"></mat-spinner>
		<div aria-live="polite">
			<strong>Enviando e analisando documento...</strong>
			<span>Aguarde enquanto preparamos o contrato.</span>
		</div>
	</ng-container>

	<ng-template #available>
		<mat-icon svgIcon="sanus-upload"></mat-icon>
		<div>
			<strong>Arraste e solte o contrato aqui</strong>
			<span>ou selecione o arquivo em uma pasta</span>
		</div>
		<button
			mat-stroked-button
			color="primary"
			type="button"
			[disabled]="isDisabled"
			(click)="fileInput.click()"
		>
			Selecionar arquivo
		</button>
	</ng-template>
</div>
